// AddStaff.jsx
import {
  Container,
  Paper,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import {
  useAddStaffMutation,
  useUpdateStaffMutation,
  useGetOneStaffQuery,
} from "slices/staffSlice";
import { useNavigate, useParams } from "react-router-dom";

function AddStaff() {
  const naviagte = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({});
  const [add] = useAddStaffMutation();
  const [update] = useUpdateStaffMutation();

  const { id } = useParams();
  const isEdit = Boolean(id);

  const {
    data: initialData,
    isSuccess,
    isFetching,
  } = useGetOneStaffQuery(id, {
    skip: !isEdit,
  });

  useEffect(() => {
    if (isEdit && isSuccess && initialData) {
      setFormData(initialData);
    }
  }, [isEdit, isSuccess, initialData]);

  console.log("initialData", initialData);

  const steps = ["Personal Info", "Locations", "Modules"];

  const handleNext = (newData) => {
    setFormData((prev) => ({ ...prev, ...newData }));
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = (newData) => {
    if (newData) {
      setFormData((prev) => ({ ...prev, ...newData }));
    }
    setActiveStep((prev) => prev - 1);
  };

  const handleSubmit = async (newData) => {
    setFormData((prev) => ({ ...prev, ...newData }));

    const finalData = { ...formData, ...newData };

    try {
      if (isEdit) {
        await update({ id, body: finalData }).unwrap();
        naviagte("/staff"); // redirect after success
      } else {
        await add(finalData).unwrap();
        naviagte("/staff"); // redirect after success
      }
    } catch (err) {
      console.log("errr", err);
    }
  };

  const getStepComponent = () => {
    switch (activeStep) {
      case 0:
        return <Step1 initialData={formData} onNext={handleNext} />;
      case 1:
        return (
          <Step2
            initialData={formData}
            onNext={handleNext}
            onBack={handleBack}
          />
        );
      case 2:
        return (
          <Step3
            initialData={formData}
            onNext={handleSubmit}
            onBack={handleBack}
          />
        );
      default:
        return <Typography variant="h6">All steps completed.</Typography>;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Typography variant="h4">
          Step {activeStep + 1}: {steps[activeStep]}
        </Typography>
        <Paper elevation={3} sx={{ p: 3, mt: 2 }}>
          <Stepper activeStep={activeStep}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {getStepComponent()}
        </Paper>
      </Container>
    </DashboardLayout>
  );
}

export default AddStaff;
